const maxCharacters = 1300;

export const formatTextMessage = (textMessage) => {
  const textMessageLength = textMessage.length;
  return textMessageLength > maxCharacters ? `${textMessage.slice(0, maxCharacters - 3)}...` : textMessage;
};

export const isTextMessageLarge = (textMessage) => {
  return textMessage.length > maxCharacters;
};